import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function HeroSection() {
  return (
    <section className="relative w-full pt-16 overflow-hidden">
      <div className="relative h-[420px] md:h-[560px] w-full">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20Korean%20manhwa%20inspired%20hero%20banner%2C%20soft%20watercolor%20style%20with%20warm%20orange%20and%20peach%20gradients%2C%20floating%20comic%20panel%20frames%2C%20subtle%20speech%20bubbles%2C%20dreamy%20atmospheric%20background%2C%20no%20text%2C%20artistic%20creative%20composition&width=1920&height=900&seq=hero-bg-comic-01&orientation=landscape"
          alt="哈哈漫画网 - 韩国漫画免费在线观看平台"
          title="哈哈漫画网 - 韩国漫画免费在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4 max-w-4xl w-full">
            <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
              韩国漫画免费在线观看
            </h1>
            <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
              高清韩漫全集下拉式阅读，漫画大全一网打尽。<br className="hidden sm:block" />
              随时随地畅读各种精彩作品，享受便捷的娱乐服务。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </Link>
              <Link
                to="/category/hot"
                className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                热门推荐
              </Link>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-2 pb-6">
          {comics.slice(0, 5).map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="hidden sm:flex items-center gap-2 bg-background-50/15 backdrop-blur-md rounded-full px-3 py-1.5 border border-background-50/20 hover:bg-background-50/25 transition-all cursor-pointer"
              title={comic.title}
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-7 h-10 rounded object-cover object-top"
              />
              <span className="text-xs text-background-50/90 whitespace-nowrap max-w-[80px] truncate">{comic.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}